import { BaseItem, NullablePartial } from '../common';
import { Intent, UpsertValues as UpsertIntent } from './intent';

export type LocalizationEntry = NullablePartial<{
  content: string;
  subject: string | null;
}>;
export interface LocalizationMap {
  [language: string]: LocalizationEntry;
}

export enum Source {
  Manual = 'MANUAL',
  Generated = 'GENERATED',
  Broadcast = 'BROADCAST',
}

export enum Kind {
  Email = 'EMAIL',
  Sms = 'SMS',
  Voice = 'VOICE',
}

export enum EntityKind {
  Encounter = 'Encounter',
  PatientOrder = 'PatientOrder',
  EhrInformation = 'EhrInformation',
}

interface BaseContent {
  name: string;
  uniqueName: string;
  organizationId: string | null;
  kind: Kind;
  localizations: LocalizationMap;
  deletedTimestamp: Date | null;
  source?: Source;
  intents: Intent[];
}

export interface Content extends BaseContent, BaseItem {}

export type CreateValues = NullablePartial<
  Omit<
    BaseContent,
    'deletedTimestamp' | 'localizations' | 'intents' | 'uniqueName'
  > & {
    localizations: LocalizationMap;
    intents: UpsertIntent[];
  }
>;
export type UpdateValues = Partial<
  Omit<BaseContent, 'localizations' | 'intents'> & {
    localizations: LocalizationMap;
    intents: UpsertIntent[];
  }
>;
export type FindAllOptions = Partial<{
  q: string;
  organizationIds: string[];
  kind: Kind;
  includeDeleted: boolean;
  source: Source;
  name: string;
}>;

export interface SendTestValues {
  entityKind: EntityKind;
  entityId: string;
  destination: string;
}
export interface SendTestResponse {
  source: Source;
  success: boolean;
  error?: Error;
}

export interface CloneValues {
  newName: string;
}
export interface CloneResponse {
  id: string;
}
